<template>
  <el-radio-group v-model="selectKey" @change="changeHandler">
    <el-radio
      v-for="item in applicationList"
      :key="item.appKey"
      :label="item.appKey"
    >{{ item.appName }}</el-radio>
  </el-radio-group>
</template>

<script>
export default {
  name: 'TrankingGroup',
  props: {
    appkey: {
      type: String,
      default: ''
    },
    applicationList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectKey: ''
    }
  },
  watch: {
    appkey(newV) {
      this.selectKey = newV
    }
  },
  methods: {
    changeHandler(val) {
      this.$emit('commitEvent', val)
    }
  }
}
</script>
